import { useQuery } from "@tanstack/react-query";
import { Actuality } from "../models/actuality";
import { ActualitiesApi } from "../services";
import { ActualityItem } from "../components/actualities/actualityItem";
import { useEffect, useRef, useState } from "react";
import { Pagination } from "../components/pagination";

export const ActualitiesPage = () => {
    const { data: actualitiesData, isLoading, error } = useQuery<Actuality[]>({
        queryKey: ["actualities"],
        queryFn: ActualitiesApi.getActualities,
    });

    const [page, setPage] = useState(0);
    const ref = useRef<HTMLDivElement>(null);

    const itemsPerPage = 5;

    const scrollToElement = (): void => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToElement();
    }, [page]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading users</div>;
    }

    const actualities = actualitiesData ?? [];

    if (!actualities) {
        return <div>404</div>
    }

    return (
        <div className="flex flex-col pb-7">
            <div className="flex flex-col relative bg-[url('../public/cats/Mendeleev_Monoid_CZ.jpg')] bg-cover bg-center p-20 bg-fixed">
                <div className="absolute inset-0 bg-black opacity-65"></div>
                <div className="flex flex-col text-center">
                    <div className="text-white z-10 text-5xl">
                        Aktuality
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-full lg:w-3/4 xl:w-2/3 mx-auto space-y-8 mt-7 px-3" ref={ref}>
                {actualities.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                    .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
                    .map((actuality, key) => (
                        <ActualityItem actuality={actuality} key={key} />
                    ))}
                <div className="mx-5">
                    <Pagination setPage={setPage} page={page} itemsPerPage={itemsPerPage} numberOfItems={actualities.length} containerRef={ref} />
                </div>
            </div>
        </div>
    )
}